import { api } from '@/api';

export interface GetChatDocumentGetOriginalDownloadRequest {
  chatDocumentId: string;
}

export interface GetChatDocumentGetOriginalDownloadResponse {
  downloadPath: string;
  downloadToken: string;
  documentName?: string;
}

/** Signed URL for the original uploaded file; `/document/get-document` serves the viewing rendition. */
const chatDocumentGetOriginalDownloadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChatDocumentGetOriginalDownload: builder.query<
      GetChatDocumentGetOriginalDownloadResponse,
      GetChatDocumentGetOriginalDownloadRequest
    >({
      query: (arg) => ({
        url: '/document/get-download',
        method: 'GET',
        params: { fletchDocumentId: arg.chatDocumentId },
      }),
    }),
  }),
});

export const { useLazyGetChatDocumentGetOriginalDownloadQuery } = chatDocumentGetOriginalDownloadApi;
